import { render, staticRenderFns } from "./FormulationProvisionalProductSpecificationTab.vue?vue&type=template&id=08537092&scoped=true&"
import script from "./FormulationProvisionalProductSpecificationTab.vue?vue&type=script&lang=js&"
export * from "./FormulationProvisionalProductSpecificationTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationProvisionalProductSpecificationTab.vue?vue&type=style&index=0&id=08537092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08537092",
  null
  
)

export default component.exports